// Brand + contact details used across the site. Change them here, not in components.
export const BRAND = 'MazaGift';
export const CONTACT_EMAIL = 'hello@mazagift.com';
export const CONTACT_PHONE = '(669) 232-3936';
export const CONTACT_PHONE_HREF = 'tel:+16692323936';
